<!-- Header -->
<div class="bg-white shadow-2 p-3 paylink-header">
  <div class="w-12 md:w-7 xl:w-5 mx-auto">
    <div class="paylink-header__toolbar grid grid-nogutter align-items-start">
      <div class="col-4" aria-hidden="true"></div>
      <div class="col-4 text-center">
        @if (companyDetails$ | async; as comp) {
          @if (comp.compDetails.logo) {
            <img
              class="inline-block -ml-2 md:-ml-5 w-5rem md:w-8rem"
              [src]="comp.compDetails.logo"
              [alt]="comp.compDetails | multilingualName"
            />
          } @else {
            <span class="text-2xl md:text-3xl font-bold text-primary">{{
              comp.compDetails | multilingualName
            }}</span>
          }
        }
      </div>
      <div class="col-4 flex justify-content-end">
        @if (isCompanyStateFound) {
          <app-lang-dropdown-paylink
            [companyStore]="companyDetails$ | async"
            (EmitLang)="selectedLang($event)"
          ></app-lang-dropdown-paylink>
        }
      </div>
    </div>

    @if (showTimeline()) {
      @if (paylinkSignUpSteps$ | async; as signUpSteps) {
        <div class="paylink-header-timeline-wrap">
          <p-timeline
            [value]="signUpSteps"
            layout="horizontal"
            align="bottom"
            styleClass="paylink-header-timeline"
          >
            <ng-template pTemplate="marker" let-event>
              @switch (timelineMarkerKind(event)) {
                @case ("current") {
                  <span
                    class="paylink-header-marker paylink-header-marker--current border-circle flex align-items-center justify-content-center"
                  >
                    <span class="paylink-header-marker__pulse"></span>
                  </span>
                }
                @case ("done") {
                  <span
                    class="paylink-header-marker paylink-header-marker--done border-circle flex align-items-center justify-content-center"
                  >
                    <i class="pi pi-check paylink-header-marker__icon"></i>
                  </span>
                }
                @default {
                  <span
                    class="paylink-header-marker paylink-header-marker--pending border-circle flex align-items-center justify-content-center"
                  >
                    <span class="paylink-header-marker__number">{{
                      event.stepIndex
                    }}</span>
                  </span>
                }
              }
            </ng-template>
            <ng-template pTemplate="content" let-progress>
              <div
                class="text-xs md:text-sm white-space-nowrap line-height-3 px-1 text-center"
              >
                @if (progress.isCurrentPage) {
                  <strong class="text-primary">{{
                    "PAYLINK_APP.PayLinkSteps." + progress.title | translate
                  }}</strong>
                } @else if (progress.status) {
                  <span class="text-success font-medium">{{
                    "PAYLINK_APP.PayLinkSteps." + progress.title | translate
                  }}</span>
                } @else {
                  <span class="text-600 font-medium">{{
                    "PAYLINK_APP.PayLinkSteps." + progress.title | translate
                  }}</span>
                }
              </div>
            </ng-template>
          </p-timeline>
        </div>
      } @else {
        <ng-template #stepLoader> </ng-template>
      }
    }
  </div>
</div>
<!-- Header -->
